const AUTOMATION_CONFIRM_INVITE_BUTTON = 'AUTOMATION_CONFIRM_INVITE_BUTTON';

export {
  AUTOMATION_CONFIRM_INVITE_BUTTON,
};
